import { atom, computed } from "nanostores";
import type { AssetInfo, PlotInfo, Session } from "../net/api";

export type PanelName = "login" | "menu" | "upload" | "inventory" | "transfer" | "history" | "plot" | "policy" | "public" | "placeprops" | "settings" | "marker" | "mail" | "inspector";
export interface Presence { plotId: string; name: string; ownerName: string; consentMode: string; state: "outside" | "inside" | "joined" }
export interface LookAt { entityId: string; removable: boolean }
export interface PendingPlace { code: string; pos: { x: number; y: number; z: number }; yaw: number; plotId: string; plotName: string }
export type PlaceSubmit = PendingPlace & { role: string; tags: string[]; componentsJson: string };

export const $session = atom<Session | null>(null);
export const $panel = atom<PanelName | null>("login");
export const $connection = atom<"offline" | "connecting" | "online">("offline");
export const $worldConfig = atom<unknown | null>(null);
export const $plots = atom<PlotInfo[]>([]);
export const $myAssets = atom<AssetInfo[]>([]);
export const $hotbarIndex = atom(0);
export const $placeMode = atom<{ code: string } | null>(null);
export const $remoteCount = atom(0);
/** Plots that currently have a draft (plot id → draft version); see world/plots.ts draftsAfter. */
export const $drafts = atom<Record<string, number>>({});
export const $lookAt = atom<LookAt | null>(null);
/** Set by the engine when an estate placement needs role/tags; the PlacePropsPanel edits it. */
export const $pendingPlace = atom<PendingPlace | null>(null);
/** Set by the UI to send a placement; the engine sends it and clears it. */
export const $placeSubmit = atom<PlaceSubmit | null>(null);
export const $historyCode = atom<string | null>(null);
export const $transferCode = atom<string | null>(null);
export const $presence = atom<Presence | null>(null);
export const $policyCode = atom<string | null>(null);
export const $myPlots = computed($session, (s) => s?.plots ?? []);
export const $toast = atom<string | null>(null);

export function roleIn(plotId: string): "owner" | "builder" | "" {
  return $myPlots.get().find((p) => p.id === plotId)?.role ?? "";
}

let toastTimer: ReturnType<typeof setTimeout> | undefined;
export function toast(msg: string, ms = 3000): void {
  $toast.set(msg);
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => $toast.set(null), ms);
}

/** Incremented by the UI to ask the server to move the player out of the current plot (LeavePlot{eject}). */
export const $leaveRequest = atom(0);

/** Local player position for panels (updated twice a second by the session). */
export const $playerPos = atom<{ x: number; z: number }>({ x: 0, z: 0 });
